module.exports = __webpack_public_path__ + "static/lolipop-13ed61924ddcdf4bbbcc93abcf09cf3c.webp";